// Resolve agent extension -> full name for CRM displays (Batch 1, item 7).
//
// Source: GET /auth/users/names (any authenticated user, id/extension/fullName
// only). That endpoint is additive and only becomes active after the next
// backend restart. Until then the request falls through to the SPA catch-all
// and returns HTML, so we detect the wrong shape and fall back to showing the
// raw extension. The signed-in user is always resolvable from /auth/me, so an
// agent sees at least their OWN name immediately, everyone else's the moment
// the endpoint goes live.

import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function useAgentNames() {
  const { user } = useAuth();
  const [map, setMap] = useState({});

  useEffect(() => {
    let alive = true;
    const seed = {};
    if (user && user.extension && user.fullName) seed[user.extension] = user.fullName;
    api.get('/auth/users/names')
      .then((r) => {
        if (!alive) return;
        const list = r.data && Array.isArray(r.data.users) ? r.data.users : null;
        if (!list) { setMap(seed); return; }            // endpoint not active yet (got HTML)
        const m = { ...seed };
        list.forEach((u) => { if (u && u.extension) m[u.extension] = u.fullName; });
        setMap(m);
      })
      .catch(() => { if (alive) setMap(seed); });
    return () => { alive = false; };
  }, [user]);

  // Falls back to the extension itself so a display never goes blank.
  const nameOf = (ext) => (ext ? (map[ext] || ext) : null);
  return { nameOf, namesMap: map };
}
